import { isEmpty } from 'lodash';

export const check0DepositAgent = (currentUser) => {
  const clientTypes = window.ecom.craftConfig.depositAgent || [];
  const { client_type_id: clientTypeId = null } = currentUser || {};

  return (
    clientTypeId && !isEmpty(clientTypes) && clientTypes.includes(clientTypeId)
  );
};
